import { defineHotpadsEvent, trackHotpadsEventDefinition } from '../track';
import type { HotpadsClickstreamListing } from '../types';

type PriceHistoryEvent = 'viewed' | 'expanded' | 'collapsed';

type Registration = {
  eventTypeId: string;
  semanticEvent: string;
  source: string;
};

export const priceHistoryEventRegistrations: Record<PriceHistoryEvent, Registration> = {
  viewed: { eventTypeId: '10670', semanticEvent: 'view_content', source: 'price_history' },
  expanded: {
    eventTypeId: '10671',
    semanticEvent: 'show_more_price_history',
    source: 'button_to_show_more_price_history',
  },
  collapsed: {
    eventTypeId: '10672',
    semanticEvent: 'show_less_price_history',
    source: 'button_to_show_less_price_history',
  },
};

export function emitPriceHistoryEvent(listing: HotpadsClickstreamListing | null, event: PriceHistoryEvent): void {
  const registration = priceHistoryEventRegistrations[event];
  if (!listing) return;
  trackHotpadsEventDefinition(
    defineHotpadsEvent({
      key: `hdp.price_history_${event}`,
      eventTypeId: registration.eventTypeId,
      eventTypeVersionId: '1',
      eventTemplateId: '4',
      eventTemplateVersionId: '1',
      trigger: {
        type: event === 'viewed' ? 'impression' : 'interaction',
        location: 'home_details',
        source: registration.source,
        object: 'home_details_component|price_history',
      },
      semanticEvent: registration.semanticEvent,
    }),
    { listing: { ...listing, units: undefined } },
  );
}
